/**
 * @generated SignedSource<<88ce69de435871993d2df66bfb8fa7cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteEnrolmentInput = {
  clientMutationId?: string | null | undefined;
  enrolmentId: string;
};
export type DeleteEnrolmentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteEnrolmentInput;
};
export type DeleteEnrolmentMutation$data = {
  readonly deleteEnrolment: {
    readonly deletedEnrolmentId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
    readonly updatedEnrolmentsInWaitingList: ReadonlyArray<{
      readonly id: string;
      readonly positionInWaitingList: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type DeleteEnrolmentMutation = {
  response: DeleteEnrolmentMutation$data;
  variables: DeleteEnrolmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedEnrolmentId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "EnrolmentNode",
  "kind": "LinkedField",
  "name": "updatedEnrolmentsInWaitingList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionInWaitingList",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteEnrolmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteEnrolmentPayload",
        "kind": "LinkedField",
        "name": "deleteEnrolment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteEnrolmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteEnrolmentPayload",
        "kind": "LinkedField",
        "name": "deleteEnrolment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedEnrolmentId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae0b6342045afd6f93e835ed39857146",
    "id": null,
    "metadata": {},
    "name": "DeleteEnrolmentMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteEnrolmentMutation(\n  $input: DeleteEnrolmentInput!\n) {\n  deleteEnrolment(input: $input) {\n    success\n    errors\n    deletedEnrolmentId\n    updatedEnrolmentsInWaitingList {\n      id\n      positionInWaitingList\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9c8e16cefc491b0b7f16fee4aa1292e";

export default node;
